// import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useState, useEffect } from "react";
// import { useLangUrl } from '../../../utilities/useLangUrl';

export default function AdminPageLink() {
    // const { i18n } = useTranslation();
    const [isLogIn, setIsLogIn] = useState(false);
    // const langUrl = useLangUrl();

    useEffect(() => {
        if (Cookies.get('token')) {
            setIsLogIn(true)
        } else {
            setIsLogIn(false)
        }
    }, [isLogIn]);

    if (isLogIn) {
        return null; // Don't render the link if not logged in
    }

    return (
        <span className="float-start ms-3 font-monospace">
            <a className="c-darkBeige" href={`/admin`}
            // onClick={(e) => {
            //     e.preventDefault();
            //     i18n.changeLanguage('ar')
            //     // changeLanguage('ar');
            //     // window.location.reload();
            // }}
            >
                admin
            </a>
        </span>
    );
}